import { render, staticRenderFns } from "./PermissionOfficeStaffImporter.vue?vue&type=template&id=f80f4820&scoped=true"
import script from "./PermissionOfficeStaffImporter.vue?vue&type=script&lang=js"
export * from "./PermissionOfficeStaffImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f4820",
  null
  
)

export default component.exports